import React from 'react';
import { formatCurrency } from '../../lib/helpers/formatters';

const TotalTr = ({ totals = {}, stickyInfo = [], children = [] }) => {
  const { totalExtraShare = 0, totalAdminShare = 0 } = totals;

  const cells = [
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    '-',
    formatCurrency(totalExtraShare),
    formatCurrency(totalAdminShare),
    '-',
  ];

  return (
    <tr className="summary-tr">
      {children.map((child, idx) => {
        const isSticky = child?.props?.sticky;
        const style = stickyInfo?.[idx]?.style || {};
        return (
          <td
            key={idx}
            className={isSticky ? 'sticky' : undefined}
            style={isSticky ? style : undefined}
          >
            {cells[idx] !== undefined ? cells[idx] : '-'}
          </td>
        );
      })}
    </tr>
  );
};

export default TotalTr;
